import React, { Component } from 'react'
import { post } from '../../../utils/networking'
import { Route, NavLink, HashRouter } from "react-router-dom";
import { connect } from 'react-redux'
import * as Notification from '../../../notification'
import $ from 'jquery'
import { configs } from '../../../helpers/constants';
import ReCAPTCHA from 'react-google-recaptcha'
import FacebookProvider, { Login, LoginButton } from 'react-facebook'
import { jsonFromUrlParam } from '../../../utils'

export class RegisterForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isVerify: false,
            referralId: "",
            isCreating: false
        }
    }

    search(search) {

        if (search) {
            const searchParams = jsonFromUrlParam(search)
            this.setState({
                referralId: searchParams.referralcode
            })
        }
    }

    componentWillMount() {
        this.search(window.location.search);
    }

    checkPass(value) {
        return (value && /^(?=.*[A-Za-z!@#$&*])(?=.*\d)[A-Za-z!@#$&*\d]{8,}$/g.test(value))
    }

    submitHandle() {
        Notification.hide();
        this.setState({
            isCreating: true
        })
        var new_user = {
            first_name: this.refs.first_name,
            last_name: " ",
            user_mail: this.refs.user_mail,
            phone: this.refs.phone,
            new_pass: this.refs.new_pass,
            re_pass: this.refs.re_pass,
            referralId: this.state.referralId
        };
        var current_component = this;
        var check = 0;
        if (this.checkPass(new_user.new_pass.value)) {
            Object.keys(new_user).forEach(function (key) {
                if (new_user[key].value) {
                    if (new_user[key].value.length < 1) {
                        check = 1;
                        Notification.show($("#" + key), "", "fail", "1");
                        Notification.show($("." + key), "", "fail", "1");
                        return;
                    }
                }
            });
            if (check == 1 || this.state.isVerify === false) {
                if (check == 1)
                    Notification.show($("#create_submit"), "Please fill out all fields.", "fail", "0");
                else
                    Notification.show($("#create_submit"), "Please prove you are not a robot.", "fail", "0");
            }
            else {
                if (this.checkMail(new_user.user_mail.value)) {
                    if (new_user.new_pass.value === new_user.re_pass.value) {
                        const param = {
                            password: new_user.new_pass.value,
                            confirmPassword: new_user.re_pass.value,
                            firstName: new_user.first_name.value,
                            lastName: "",
                            email: new_user.user_mail.value.toLowerCase(),
                            referralId: new_user.referralId,
                            phone: new_user.phone.value
                        }
                        post('user/register', param, "customer", () => {
                            this.setState({
                                isCreating: false
                            })
                            Notification.show($("#create_submit"), "Registration successful. Please check your mail.", "success", "0");

                        }, errors => {
                            this.setState({
                                isCreating: false
                            })
                            Notification.show($("#create_submit"), errors.error, "fail", "0");
                        })
                    }
                    else {
                        this.setState({
                            isCreating: false
                        })
                        Notification.show($("#re_pass"), "Password doesn't match.", "fail", "1");
                    }
                }
                else {
                    this.setState({
                        isCreating: false
                    })
                    Notification.show($("#user_mail"), "Please match the requested email format.", "fail", "1");
                }
            }
        }
        else {
            this.setState({
                isCreating: false
            })
            Notification.show($("#new_pass"), "New password must be minimum eight characters, at least one letter and one number.", "fail", "0");
        }
    }

    checkMail(mail) {
        var regExp = new RegExp("[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$");
        return regExp.test(mail);
    }

    verifyCallback() {
        this.setState({ isVerify: true });
    }
    handleChangReferralCode(e) {
        this.setState({
            referralId: e.target.value
        })
    }

    render() {
        let {
            referralId,
            isCreating
        } = this.state;
        return (
            <div id="register_page" className="user_page">
                <div id="register_form">
                    <div id="register_panner">
                        <div id="panner_title_1">
                            <p>Your Spa & Wellness Destination</p>
                        </div>
                        <div id="panner_title_2">
                            <p>MASSAGE • FACIALS • YOGA • & MORE</p>
                        </div>
                        <div id="login_fb_button_2">
                            <FacebookProvider appId="1837433456548793">
                                <LoginButton
                                    scope={"email"}
                                    onError={error => alert("error" + error)}
                                >Login with facebook</LoginButton>
                            </FacebookProvider>
                        </div>
                    </div>
                    <div id="register_title">
                        <p>or</p>
                        <fieldset >
                            <legend>Create an Account</legend>
                        </fieldset>
                    </div>
                    <div id="register_detail">
                        <div id="user_info">
                            <div className="first_name">
                                <input type="text" ref="first_name" placeholder="Full Name" />
                            </div>
                        </div>
                        <div id="user_mail">
                            <input type="text" ref="user_mail" placeholder="Email" />
                        </div>
                        <div id="phone">
                            <input type="text" ref="phone" placeholder="Phone number" />
                        </div>
                        <div id="new_pass">
                            <input type="password" ref="new_pass" placeholder="Create password" />
                        </div>
                        <div id="re_pass">
                            <input type="password" ref="re_pass" placeholder="Retype password" />
                        </div>
                        <div className="space">
                            <label>Who referred you to Nailspaofamerica.com?</label>
                            <span>Please enter your referring member's Referral Code:</span>
                        </div>
                        <div id="referral_code">
                            <input
                                type="text"
                                ref="referral_code"
                                placeholder="Referral Code"
                                value={referralId}
                                onChange={this.handleChangReferralCode.bind(this)} />
                        </div>
                        <div id="register_captcha">
                            <ReCAPTCHA
                                ref="recaptcha"
                                sitekey="6Lc0MUUUAAAAACvMe9KDmSoxrpwYcDXHXeqsONW2"
                                onChange={this.verifyCallback.bind(this)}
                                className="captcha"
                            />
                        </div>
                        <div id="create_submit" >
                            <span>Already a member? <NavLink to="/login">Sign in here</NavLink></span>
                            <button className="button" onClick={this.submitHandle.bind(this)}>{isCreating ? "wating..." : "Sign up"}</button>
                        </div>
                    </div>
                </div>
                <div id="load_panner">
                    <div className="anim    ationload">
                        <div className="osahanloading"></div>
                    </div>
                </div>
            </div>
        )
    }
}
export default RegisterForm


// WEBPACK FOOTER //
// ./src/components/user/register/index.js